/**
 * Texts for header
 */
export const headerText = {
    cookiesIntroText: 'Käytämme evästeitä ainoastaan verkkosivustomme käytön seurantaan. Emme tallenna henkilötietoja.',
    cookiesAccept: 'Hyväksy evästeet',
    cookiesDeny: 'Hylkää evästeet',
    tabFAQs: 'Usein kysyttyjä kysymyksiä',
    tabSupport: 'Tuki',
    tabHistory: 'Historia',
    tabReviews: 'Tarinat',
    tabTraining: 'Koulutus',
    tabUserTraining: 'Käyttäjäkoulutus',
    tabHcpTraining: 'Terveydenhuollon koulutus',
    tabCamAPSLiberty: 'CamAPS Liberty',
    tabPregnancy: 'Raskaus',
    tabAbout: 'Tietoa meistä',
    tabNews: 'Uutiset',
    tabCareers: 'Ura',
    tabOrders: '',
    tabNotifications: 'Ilmoitukset',
};
